import { AnalysisTest as _AnalysisTest } from '@team-milva/lab-models/resources'
import { t } from '@/locales'

export class AnalysisTest extends _AnalysisTest {
  get typeName(): string {
    switch (this.type) {
      case 'prove-based':
        return t('area.analysis-test.type.prove-based')
      case 'value-based':
        return t('area.analysis-test.type.value-based')
      case 'single-select':
        return t('area.analysis-test.type.single-select')
      case 'multi-select-text':
        return t('area.analysis-test.type.multi-select-text')
      case 'multi-select-number':
        return t('area.analysis-test.type.multi-select-number')
    }
  }
}
